export default __webpack_public_path__ + "static/media/reports.a2c10296.svg";